import { cn } from '@utils/cn';
import { type ComponentProps } from 'react';

const TimelineEyebrow = ({
  className,
  children,
  ...props
}: ComponentProps<'span'>) => {
  return (
    <span className={cn('text-sm text-muted-foreground', className)} {...props}>
      {children}
    </span>
  );
};

export { TimelineEyebrow };
